import { createListenerMiddleware } from '@reduxjs/toolkit'
import { LOCATION_CHANGE } from 'connected-react-router'
import { SET_BYPASS_REGION_EXCLUSION_OFFER_IDS, SET_BYPASS_REGION_SETTING_ID } from 'actions/actionConstants'
import { getOfferBypassRegionFilterSetting } from 'api/promo'
import { setCookie } from 'lib/web/cookieUtils'

const EXCLUSION_IDS_COOKIE_KEY = 'bypass_region_exclusion_ids'
const SETTING_ID_COOKIE_KEY = 'bypass_region_setting_id'
const COOKIE_TTL_SECONDS = 7 * 24 * 60 * 60 // 7 days

const bypassRegionMiddleware = createListenerMiddleware()

bypassRegionMiddleware.startListening({
  type: LOCATION_CHANGE,
  effect: async(_action, listenerApi) => {
    const state = listenerApi.getState() as App.State
    if (state.marketing.bypassRegionSettingId) {
      listenerApi.unsubscribe()
      return
    }

    const { source, medium, campaign, term } = state.utm
    if (!source) {
      listenerApi.unsubscribe()
      return
    }

    listenerApi.unsubscribe()

    try {
      const result = await getOfferBypassRegionFilterSetting({
        source: source || undefined,
        medium: medium || undefined,
        campaign: campaign || undefined,
        term: term || undefined,
      })

      if (result.setting_id) {
        setCookie(SETTING_ID_COOKIE_KEY, result.setting_id, COOKIE_TTL_SECONDS, '/', 'Lax', document.domain)
        listenerApi.dispatch({ type: SET_BYPASS_REGION_SETTING_ID, settingId: result.setting_id })
      }

      if (result.offer_region_filter_exclusion_offer_ids.length > 0) {
        setCookie(EXCLUSION_IDS_COOKIE_KEY, result.offer_region_filter_exclusion_offer_ids.join(','), COOKIE_TTL_SECONDS, '/', 'Lax', document.domain)
        listenerApi.dispatch({ type: SET_BYPASS_REGION_EXCLUSION_OFFER_IDS, offerIds: result.offer_region_filter_exclusion_offer_ids })
      }
    } catch {
      // non-critical — bypassRegionSettingId stays unset
    }
  },
})

export default bypassRegionMiddleware
